export var system = {
    browser: undefined,
    isMobile : undefined,
}

export function runNavigator() {
    if(system.browser === undefined || system.isMobile === undefined) {
        var agent = navigator.userAgent.toUpperCase();
        if (agent.indexOf('TRIDENT') >= 0) {
            system.browser = 'IE';
        } else if (agent.indexOf('FIREFOX') >= 0) {
            system.browser = 'FIREFOX';
        } else if (agent.indexOf('EDG') >= 0) {
            system.browser = 'EDGE';
        } else if (agent.indexOf('SAFARI') >= 0) {
            system.browser = 'SAFARI';
        } else if (agent.indexOf('CHROME') >= 0) {
            system.browser = 'CHROME';
        } else {
            system.browser = '';
        }

        system.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        console.log("browser:" + system.browser + " isMobile:" + system.isMobile);
    }
}

export var DateFormat = {
    yyyymmddhhmmss_iso8601: function() {
        var d = new Date();
        var month = d.getUTCMonth();
        month++;
        if (month < 10) month = "0" + month;
        var day = d.getUTCDate();
        if (day < 10) day = "0" + day;
        var year = d.getUTCFullYear();
        var hour = d.getUTCHours();
        if (hour < 10) hour = "0" + hour;
        var minute = d.getUTCMinutes();
        if (minute < 10) minute = "0" + minute;
        var second = d.getUTCSeconds();
        if (second < 10) second = "0" + second;
        var newdate = year + "-" + month + "-" + day + "T" + hour + ":" + minute + ":" + second + "Z";
        return newdate;
    },
    
    yyyymmddhhmmss: function() {
        now = new Date();
        year = "" + now.getFullYear();
        month = "" + (now.getMonth() + 1);
        if (month.length == 1) {
            month = "0" + month;
        }
        day = "" + now.getDate();
        if (day.length == 1) {
            day = "0" + day;
        }
        hour = "" + now.getHours();
        if (hour.length == 1) {
            hour = "0" + hour;
        }
        minute = "" + now.getMinutes();
        if (minute.length == 1) {
            minute = "0" + minute;
        }
        second = "" + now.getSeconds();
        if (second.length == 1) {
            second = "0" + second;
        }
        milliseconds = "" + now.getMilliseconds();
        if (milliseconds.length == 1) {
            milliseconds = "00" + milliseconds;
        }
        if (milliseconds.length == 2) {
            milliseconds = "0" + milliseconds;
        }
        return year + month + day + hour + minute + second + milliseconds;
    },
    
    yyyymmddText: function(date, separator) {
        return date.substring(0,4) + separator + date.substring(4,6) + separator + date.substring(6,8);
    },
    
    leftPad(value) {
        if (value >= 10) {
            return value;
        }
        
        return `0${value}`;
    },
    
    yymmdd(millis, delimiter = '-') {
        const date = new Date(millis);
        const year = `${date.getFullYear()}`.slice(2);
        const month = this.leftPad(date.getMonth() + 1);
        const day = this.leftPad(date.getDate());
        
        return [year, month, day].join(delimiter);
    },
};

var timeStamp = {
    startTime : 0,
    start : function () {
        this.startTime = +new Date();
        console.log("timeStamp start");
    },
    print : function () {
        if(this.startTime === 0) {
            return;
        }
        let cur = +new Date();
        let timestamp = cur - this.startTime;
        console.log("timestamp print: "+timestamp+"ms");
        this.startTime = 0;
    }
};

export let uniqueId = {
    _id: null,
    get: function () {
        let uid = Date.now();
        if (null != this._id) {
            while (uid <= this._id) {
                uid = Date.now();
            }
        }
        return this._id = uid;
    },
    increment: function () {
        if (null == this._id) {
            this._id = this.get();
        }
        
        return ++this._id;
    },
    end: function () {
        this.get();
    }
};

export let listener = {
    rnothtmlwhite: (/[^\x20\t\r\n\f]+/g),

    COMMON: "_COMMON_",

    listener: null,

    event: {
        COMMON: "_COMMON_",
        model: {
            oncomplete: null,
            data: null,
        },
        listener: null,
        data: null,

        get: function () {
            return Object.assign({}, this.model);
        },

        one: function (event, uid) {
            if (event) {
                if (event.oncomplete) {
                    if (!this.listener) {
                        this.listener = [];
                    }

                    this.listener.push(event.oncomplete);
                }
                if (event.data) {
                    if (!this.data) {
                        this.data = {};
                    }
                    if (undefined == uid || null == uid) {
                        uid = this.COMMON;
                        if (!this.data[uid]) {
                            this.data[uid] = [];
                        }
                        this.data[uid].push(event.data);
                    } else {
                        this.data[uid] = event.data;
                    }
                }
            }
        },

        dispatch: function () {
            var self = this;

            if (this.listener) {
                this.listener.forEach(func => func(this.data));
            }

            this.listener = null;
            this.data = null;
        }
    },

    on: function (types, func, uid) {
        let type, t;

        types = (types || "").match(this.rnothtmlwhite) || [""];
        t = types.length;

        while (t--) {
            type = types[t];
            if (!type) {
                continue;
            }

            if (!this.listener) {
                this.listener = {};
            }

            if (!this.listener.hasOwnProperty(type)) {
                this.listener[type] = {};
            }

            if (undefined == uid || null == uid) {
                uid = this.COMMON;
            }

            if (!this.listener[type].hasOwnProperty(uid)) {
                this.listener[type][uid] = [];
            }

            this.listener[type][uid].push(func);
        }

        return this;
    },

    off: function (types, uid) {
        let type, t;

        types = (types || "").match(this.rnothtmlwhite) || [""];
        t = types.length;

        while (t--) {
            type = types[t];
            if (!type) {
                continue;
            }

            if (undefined == uid || null == uid) {
                uid = this.COMMON;
            }

            if (this.listener && this.listener.hasOwnProperty(type) && this.listener[type].hasOwnProperty(uid)) {
                delete this.listener[type][uid];
            }
        }

        return this;
    },

    dispatch: function (type, data, uid) {
        var self = this;

        if (this.listener && this.listener.hasOwnProperty(type)) {
            if (this.listener[type].hasOwnProperty(this.COMMON)) {
                this.listener[type][this.COMMON].forEach(func => self.dispatchFunc(func, data, uid));
            }

            if (undefined == uid || null == uid) {
                Object.keys(this.listener[type]).forEach(key => {
                    if (this.COMMON != key) {
                        let updata = data ? Object.assign({}, data) : {};
                        if (!updata.uid) {
                            updata.uid = key;
                        }

                        this.listener[type][key].forEach(func => self.dispatchFunc(func, updata, uid))
                    }
                });
            } else {
                if (this.listener[type].hasOwnProperty(uid)) {
                    this.listener[type][uid].forEach(func => self.dispatchFunc(func, data, uid));
                }
            }
        }

        this.event.dispatch();
    },

    dispatchFunc: function (func, data, uid) {
        let event = this.event.get();
        func(data, event);
        this.event.one(event, uid);
    },
};

/* String Extend*/
String.prototype.splice = function(idx, rem, str) {
    return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
};

String.prototype.width = function(font) {
    var f = font || '16px Noto Sans KR',
        o = $('<div></div>')
        .text(this)
        .css({'position': 'absolute', 'float': 'left', 'white-space': 'nowrap', 'visibility': 'hidden', 'font': f})
        .appendTo($('body')),
        w = o.width();
    
    o.remove();
    
    return w;
};
